import CheckForSave from "./CheckForSave";

export default function (state, payload) {
  const { campaigns } = state;
  localStorage.setItem("campaigns", JSON.stringify(campaigns));
  const currentCampaigns = JSON.stringify(campaigns);
  state = { ...state, currentCampaigns };
  return CheckForSave(state, payload);
}